import { z } from 'zod';
/** Public collection settings only. Consent and private-route exclusions cannot be disabled here. */
export const WebsiteAnalyticsSchema = z.object({
    enabled: z.boolean(),
    measurement_id: z.string().regex(/^G-[A-Z0-9]{6,20}$/),
    allowed_hosts: z.array(z.string().regex(/^[a-z0-9.-]+$/)).min(1).max(10),
    consent_days: z.number().int().min(1).max(180),
}).strict();
export const websiteAnalyticsDefaults = { enabled: true, measurement_id: 'G-V4VDJN2N1D', allowed_hosts: ['artemisflooring.com'], consent_days: 180 };
//# sourceMappingURL=website-analytics.js.map